export default function convertToString(value) {
    return JSON.stringify(value);
}
